module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00086-fs8.e3836c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00086-fs8.png
// module id = 239
// module chunks = 0